import { useOktaAuth } from '@okta/okta-react'

export const Logout = () => {
  const { oktaAuth } = useOktaAuth()
  oktaAuth.signOut()
  return null
}
